/* eslint-disable */
export default {
  region: 'Regio',
  calling: 'Bellen',
  logout: 'Afmelden',
  version: 'Versie',
  settings: 'Instellingen',
  selectToDialSMS: "Selecteren om te bellen/sms'en",
  selectToDial: 'Selecteren om te bellen',
  selectToSMS: "Selecteren om te sms'en",
  clickToDial: 'Click-to-dial',
  autoCreateLog: 'Automatisch een oproeplijst maken',
  autoCreateSMSLog: 'Automatisch een sms-lijst maken',
  autoLogCalls: 'Automatisch oproepen loggen',
  autoLogNotes: 'Automatisch notities loggen',
  autoLogSMS: 'Automatisch sms-berichten loggen',
  clickToSMS: 'Click-to-SMS',
  logSMSContent: 'Sms-inhoud loggen',
  clickToDialSMS: 'Click To Dial/SMS',
  logExtensionCall: 'Extensieoproepen loggen',
  audio: 'Audio',
  language: 'Taal',
  feedback: 'Feedback',
  userGuide: 'Nieuw',
  quickAccess: 'Instelling snelle toegang',
  report: 'Analyserapport',
  shareIdea: 'Een idee delen',
  openEntityFrom: 'Gedrag Salesforce-object',
  ctiPanelSize: 'Grootte van CTI-paneel',
  openInNewTab: 'Openen in een nieuw tabblad',
  openInCurrentTab: 'Openen in het huidige tabblad',
  reportIssue: 'Probleem melden',
  contactSupport: 'Contact opnemen met de klantenservice',
  selectToDialHint:
    'Selecteer voor een betere ervaring het telefoonnummer dat u wilt bellen met RingCentral via de pagina voor grote hoeveelheden telefoonnummers.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
